import { Pipe, PipeTransform } from '@angular/core';

/** Minimal shapes needed by this pipe — avoids a dependency on @cb-group-tickets. */
interface Follower {
  username: string;
  [key: string]: any;
}

@Pipe({
    name: 'followersFilter',
    standalone: true
})
export class FollowersPipe implements PipeTransform {
  /**
   * Followers in, followers out that contain all the terms in the filterText
   *
   * @param {Follower[]} followers
   * @param {string} filterText
   * @returns {Follower[]}
   */
  transform(followers: any, filterText: string): any {
    if (!followers) {
      return [];
    }
    if (!filterText) {
      return followers;
    }

    return followers.filter((follower: Follower) => {
      return this.followerContainsFilterText(follower, filterText);
    });
  }

  private followerContainsFilterText(follower: Follower, filterText: string): boolean {
    filterText = filterText.toLocaleLowerCase();
    const filterTerms = filterText.split(' ');
    for (const filterTerm of filterTerms) {
      const hasFilterTerm = this.followerContainsFilterTerm(follower, filterTerm);
      if (hasFilterTerm === false) {
        return false;
      }
    }

    return true;
  }

  private followerContainsFilterTerm(bookmark: Follower, filterTerm: string) {
    return bookmark.username.toLocaleLowerCase().includes(filterTerm);
  }
}
